import React from "react";
import { DatePicker } from "antd";
import moment from "moment";
import {
  Button,
  Label,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import AddModal from "./addmodal";

const FraudBlockListContent = ({
  searchBy,
  searchblockList,
  setSearchByValue,
  setSearchBy,
  searchByValuePlaceholder,
  searchByValue,
  fromDate,
  setFromDate,
  handlesearchBlocklist,
  toDate,
  setToDate,
  resetFilter,
  setmodal,
  handleSearch,
  modal,
  handlesaveBlocklist,
  setType,
  setIdentyId,
  type,
  identyId,
  setBlockbutton,
  blockbutton,
  searchdataLoading,
  country,
  setCountry,
  countryList,
}) => {
  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;
  return (
    <>
      <Card>
        <CardBody>
          <Row>
            <Col lg="2">
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor="exampleFormControlSelect1"
                >
                  Search by
                </label>
                <Input
                  id="exampleFormControlSelect1"
                  type="select"
                  style={{ height: "27px" }}
                  value={searchBy}
                  onChange={(e) => {
                    setSearchByValue("");
                    setSearchBy(e.target.value);
                  }}
                  className="inputFields"
                >
                  <option value="Card Serial Number">Card Serial Number</option>
                  <option value="Mobile Recharge Phone Number">
                    Mobile Recharge Phone Number
                  </option>
                  <option value="Money Transfer Account Number">
                    Money Transfer Account Number
                  </option>
                  {/* <option value="date">Date</option> */}
                </Input>
              </FormGroup>
            </Col>
            <Col lg="2">
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                >
                  Search for
                </label>
                <Input
                  className="inputFields"
                  id="example3cols2Input"
                  placeholder={searchByValuePlaceholder}
                  type="text"
                  style={{ height: "27px" }}
                  onKeyPress={(e) => e.charCode === 13}
                  onChange={(e) =>
                    setSearchByValue(e.target.value && e.target.value.trim())
                  }
                  value={searchByValue}
                />
              </FormGroup>
            </Col>
            <Col lg="2">
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor="exampleFormControlSelect1"
                >
                  Search Country
                </label>
                <Input
                  id="exampleFormControlSelect1"
                  type="select"
                  placeholder="select country"
                  style={{ height: "27px" }}
                  value={country.searchedCountry}
                  defaultValue=""
                  onChange={(e) => {
                    setCountry({
                      ...country,
                      searchedCountry: e.target.value || "",
                    });
                  }}
                  className="inputFields"
                >
                  <option hidden value="">
                    select country
                  </option>
                  {countryList.map((country) => (
                    <option value={country.code}>{country.label}</option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
            <Col lg="1" className="form-input-padding">
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                >
                  From
                </Label>
                <DatePicker
                  format={customFormat}
                  placeholder="DD-MM-YY"
                  className="formcontrol-date"
                  onChange={(e, dateString) => {
                    if (dateString && dateString != "") {
                      setFromDate(moment(dateString, dateFormat));
                    } else {
                      setFromDate(null);
                    }
                  }}
                  value={fromDate}
                  // format={dateFormat}
                />
              </FormGroup>
            </Col>
            <Col lg="1" className="form-input-padding">
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                >
                  To
                </Label>
                <DatePicker
                  format={customFormat}
                  placeholder="DD-MM-YY"
                  className="formcontrol-date"
                  onChange={(e, dateString) => {
                    if (dateString && dateString != "") {
                      setToDate(moment(dateString, dateFormat));
                    } else {
                      setToDate(null);
                    }
                  }}
                  value={toDate}
                />
              </FormGroup>
            </Col>
            <Col
              lg="1"
              style={{ marginTop: "9px" }}
              className="form-input-padding"
            >
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                ></Label>
                <div>
                  <Button
                    type="button"
                    style={{
                      width: "100%",
                      background: "#e91d24",
                      color: "white",
                      height: "26px",
                      border: "1px solid rgb(233, 29, 36)",
                    }}
                    id="example3cols2Input"
                    className="filter-button"
                    onClick={() => handleSearch(true)}
                  >
                    <div>
                      <i class="fas fa-search"></i>
                    </div>
                  </Button>
                </div>
              </FormGroup>
            </Col>
            <Col
              lg="1"
              style={{ marginTop: "9px", padding: "0px 6px" }}
              className="form-input-padding"
            >
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                ></Label>
                <div>
                  <Button
                    color="light"
                    type="button"
                    style={{ width: "100%", height: "26px" }}
                    id="example3cols2Input"
                    className="filter-button"
                    onClick={() => resetFilter()}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      <i class="fas fa-redo-alt 2px"></i> Reset
                    </div>
                  </Button>
                </div>
              </FormGroup>
            </Col>
            <Col
              lg="1"
              style={{ marginTop: "9px" }}
              className="form-input-padding"
            >
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                ></Label>

                <Button
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "26px",
                  }}
                  color="primary"
                  type="button"
                  id="example3cols2Input"
                  className="filter-button-beneficiery"
                  onClick={() => setmodal(true)}
                >
                  <div>ADD</div>
                </Button>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <AddModal />
      <AddModal
        show={modal}
        onHide={() => {
          setmodal(false);
          setType(() => []);
          setIdentyId(() => "");
          setBlockbutton(false);
          setCountry({ ...country, selectedCountry: [] });
        }}
        handleChange={(selectedOption) => {
          setType([{ ...selectedOption }]);
          setIdentyId([]);
        }}
        handleCountryChange={(selectedOption) => {
          setCountry({ ...country, selectedCountry: [{ ...selectedOption }] });
        }}
        idinputOnchange={(e) => {
            const inputValue = e.target.value;
            // Use a regular expression to check if the input is alphanumeric
            const alphanumericRegex = /^[a-zA-Z0-9]+$/;

            if (alphanumericRegex.test(inputValue)) {
                setIdentyId(inputValue);
            }
        }}
        back={() => {
          setBlockbutton(false);
          // setType([]);
          // setIdentyId([]);
        }}
        handlesaveBlocklist={handlesaveBlocklist}
        searchdataLoading={searchdataLoading}
        setType={setType}
        searchblockList={searchblockList}
        setIdentyId={setIdentyId}
        type={type}
        identyId={identyId}
        blockbutton={blockbutton}
        search={handlesearchBlocklist}
        country={country.selectedCountry}
        countryList={countryList}
      />
    </>
  );
};

export default FraudBlockListContent;
